export default __webpack_public_path__ + "31308f792383ec093ff4e98228209e7a.jpg";